(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('validateUrl', ValidateUrl);

    function ValidateUrl(ValidatorHelper) {
        function verifyUrl(url) {
            return ValidatorHelper.validateUrl(url);
        }

        function link(scope, elem, attrs, ctrl) {
            scope.$watch(attrs.ngModel, function (value) {
                if (verifyUrl(value))
                    ctrl.$setValidity('url', true);
                else
                    ctrl.$setValidity('url', false);
            })
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            link: link
        }
    }
}());